module.exports = __webpack_public_path__ + "img/message.efa58040.png";